<template>
  <div class="promoter-order" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">累计推广订单</div>
          <div>
            <span class="num">{{ count }}</span
            >单
          </div>
        </div>
        <div class="iconfont icon-2"></div>
      </div>
    </div>
    <div class="list">
      <div class="item">
        <!--        <div class="title acea-row row-column row-center">-->
        <!--          <div>本月累计推广订单：{{ where.param.count ? where.param.count : 0 }}单 </div>-->
        <!--        </div>-->
        <div class="listn">
          <div class="itenm" v-for="(val, indexn) in list" :key="indexn">
            <div class="top acea-row row-between-wrapper">
              <div class="pictxt acea-row row-between-wrapper">
                <div class="pictrue">
                  <img :src="val.picture" />
                </div>
                <div class="text line1">{{ val.nickname }}</div>
              </div>
              <div class="money">
                返佣：<span class="font-color-red"
                  >￥{{ val.money ? val.money : 0 }}</span
                >
              </div>
            </div>
            <div class="bottom">
              <div>
                <span class="name">订单编号：</span>act{{ val.orderId
                }}{{ val.id }}
              </div>
              <div>
                <span class="name">下单时间：</span
                >{{ fromatDate(val.created) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getSpreadOrder } from "@api/activity";
import Loading from "@components/Loading";
import dayjs from "dayjs";
export default {
  name: "PromoterOrder",
  components: {
    Loading,
  },
  props: {},
  data: function () {
    return {
      list: [],
      id: this.$route.params.id,
      where: {
        pageNO: 1,
        param: {},
        pageSize: 15,
      },
      loaded: false,
      loading: false,
      loadTitle: "",
      count: "",
    };
  },
  mounted: function () {
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getIndex();
    });
  },
  methods: {
    fromatDate(time) {
      return dayjs.unix(time).format("YYYY-MM-DD hh:mm:ss");
    },
    getIndex: function () {
      let there = this;
      if (there.loaded == true || there.loading == true) return;
      there.loading = true;
      getSpreadOrder(this.id, there.where).then(
        (res) => {
          console.info(this.where, res);
          there.loading = false;

          there.list = there.list.concat(res.result.records || []);
          there.loaded = there.list.length == res.result.total;
          there.loadTitle = there.loaded ? "人家是有底线的" : "上拉加载更多";
          there.where.pageNO = there.where.pageNO + 1;

          there.where.param = res.result.param;
          there.count = res.result.total;
        },
        (error) => {
          there.$dialog.message(error.msg);
        },
        300
      );
    },
  },
};
</script>
